import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemText,
    CircularProgress,
    Paper,
    Dialog,
    DialogTitle,
    DialogActions
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { getBookingStatusClass, SERVER_URL } from '../../utils/config/constants.js';
import { KeyboardArrowDown, FilterList } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import MenuButton from '../Menu/MenuButton.js';
import {
    BOOKING_VIEW_ALL,
    BOOKING_VIEW_INPROGRESS,
    BOOKING_VIEW_NEW,
    BOOKING_VIEW_COMPLETED
} from '../../utils/config/constants';
import { store } from '../../store';
import { NotificationManager } from 'react-notifications';
import Axios from 'axios';
import { getCookies } from '../../utils/getToken';
const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});
var isMounted = false;
class RecurringBookingList extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 1,
            scrollClicked: false,
            detailRender: false,
            bookingSelected: '',
            showScroll: true,
            bookingData: [],
            showConfirmStopDialog: false,
            selectedIndex: 0,
            selectedBooking: {},
            isUploading: false
        };
    }
    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData = () => {
        if (isMounted) {
            this.props.recurringBookingListAction(this.onDone);
        }
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({
                bookingData: data,
            });
        } else {
            NotificationManager.error("Oops!", "Something went wrong")
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };


    renderDetail = key => {
        this.setState({ detailRender: true, bookingSelected: key });
    };

    handleClose = () => {
        this.setState({
            showConfirmStopDialog: false
        })
    }
    onStopRecurringBooking = (id) => {
        this.setState({
            isUploading: true
        })
        console.log("Id:::", id)
        var authToken = getCookies();
        Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/booking/stop-recurring`,
            params: {
                booking_id: id
            },
            headers: { 'x-auth-token': authToken }
        }).then(resJson => {
            if (resJson.data.status == 'OK') {
                NotificationManager.success("Success", resJson.data.message)
                this.setState({
                    showConfirmStopDialog: false,
                    isUploading: false
                });
                this.getData();
            } else {
                console.log("recurring status ELSE::");
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    showConfirmStopDialog: false,
                    isUploading: false
                });
            }
        })

    }

    render() {
        const { classes, match } = this.props;
        const { bookingData } = this.state;

        const { formatMessage } = this.props.intl;
        const { page } = this.state;
        if (this.state.detailRender) {
            this.props.history.push({
                pathname: `/user/booking/detail/${this.state.bookingSelected}`,
                bookingId: this.state.bookingSelected,
                recurring: true
            });
        }
        return (
            <div className="tz-2-com tz-2-main">

                <div className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {bookingData.length > 0 ? (
                                <List
                                    className={classes.root + ' list-check-out'}
                                >
                                    {bookingData.map(booking => {
                                        return (
                                            <ListItem
                                                key={booking.key}
                                                className={
                                                    classes.paper +
                                                    ' home-list-pop list-spac list-check-out-inn'
                                                }
                                            >
                                                <div className="col-xl-3 col-md-12 dashboard-booklist-img 2">
                                                    <ListItemAvatar>
                                                        <ProgressiveImage
                                                            delay={2000}
                                                            src={
                                                                booking
                                                                    .bookingImage
                                                                    .medium
                                                            }
                                                            placeholder="provider-image"
                                                        >
                                                            {(src, loading) =>
                                                                loading ? (
                                                                    this.renderPromoImage()
                                                                ) : (
                                                                        <img
                                                                          className="profile_img"
                                                                            src={
                                                                                src
                                                                            }
                                                                            alt="provider image"
                                                                        />
                                                                    )
                                                            }
                                                        </ProgressiveImage>
                                                    </ListItemAvatar>
                                                </div>
                                                <div className="col-xl-6 col-md-12 col-sm-12">
                                                    <ListItemText
                                                        className=" home-list-pop-desc inn-list-pop-desc"
                                                        disableTypography={true}
                                                        primary={
                                                            <React.Fragment>
                                                                <h3>
                                                                    {
                                                                        booking.token
                                                                    }
                                                                </h3>
                                                            </React.Fragment>
                                                        }
                                                        secondary={
                                                            <React.Fragment>
                                                                <h5>
                                                                    {
                                                                        booking.services[0].service
                                                                    }
                                                                </h5>

                                                                <br />
                                                                <p>Started on : {moment(
                                                                    booking.datetime
                                                                ).format(
                                                                    'MM-DD-YYYY'
                                                                )}</p>
                                                                <p>Proposed Booking Date: {moment(
                                                                    booking.datetime + (booking.recurrance_period == 7 ? Number("604800000") : booking.recurrance_period == 15 ?
                                                                        Number("1296000000") : booking.recurrance_period == 30 ? Number("2592000000") : booking.recurrance_period == 365 ?
                                                                            Number("31536000000") : booking.recurrance_period == 180 ? Number("15552000000") : Number("15552000000"))
                                                                ).format(
                                                                    'MM-DD-YYYY'
                                                                )}</p>
                                                            </React.Fragment>
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-3 text-center">
                                                    <div>
                                                        <p>{booking.recurrance_period == 7 ? "Weekly" : booking.recurrance_period == 15 ? "Every 2 Weeks" :
                                                            booking.recurrance_period == 30 ? "Monthly" : booking.recurrance_period == 365 ? "Yearly" : booking.recurrance_period == 180
                                                                ? "Bi-Annual" : booking.recurrance_period}</p>
                                                    </div>
                                                    <Button
                                                        variant="contained"
                                                        size="medium"
                                                        color="primary"
                                                        className={
                                                            classes.margin
                                                        }
                                                        onClick={() => this.setState({ showConfirmStopDialog: true, selectedIndex: 0, selectedBooking: booking })
                                                            /* this.onStopRecurringBooking(booking.key) */}
                                                    >
                                                        STOP
                                                    </Button>
                                                </div>


                                            </ListItem>
                                        );
                                    })}


                                </List>
                            ) : (
                                    <div>
                                        <Paper>
                                            <p
                                                style={{
                                                    color: '#000',
                                                    padding: '10px'
                                                }}
                                            >
                                                <FormattedMessage
                                                    id="noBookingFound"
                                                    defaultMessage="No Booking found"
                                                />
                                            </p>
                                        </Paper>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>

                {this.state.showConfirmStopDialog && <Dialog
                    open={this.state.showConfirmStopDialog}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Do you want to stop recurrence?"}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.handleClose} style={{ color: "#ff0000" }}>
                            No
                                            </Button>
                        {this.state.isUploading ? <CircularProgress size={30} className="align-self-center" /> :
                            <Button onClick={() => this.onStopRecurringBooking(this.state.selectedBooking.key)} color="primary" autoFocus>
                                Yes
                                            </Button>}
                    </DialogActions>
                </Dialog>}

                {/* <div className="text-center">
                    {this.state.showScroll && this.renderScrollIcon()}
                </div> */}
            </div>
        );
    }
}

const mapStateToProps = ({ bookings }) => {
    return {
        bookingData: bookings.bookingData.bookingList,
        bookingDataCopy: bookings.bookingData,
        bookingLoader: bookings.bookingLoader
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(withRouter(RecurringBookingList)));



// WEBPACK FOOTER //
// ./src/components/Customer/RecurringBookingList.jsx